function init() {
  const forms = document.querySelectorAll(
    '.banner__buttons--custom form[action="/cart/add"]'
  );
  const cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");

  forms.forEach(function (form) {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      const spinner = form.querySelector(".atc-spinner");
      const button = form.querySelector(".banner__atc-button");

      if (spinner) {
        button.disabled = true;
        spinner.classList.remove("hidden");
      }

      const formData = new FormData(form);

      // Add to cart via AJAX
      await fetch("cart/add.js", {
        method: "POST",
        body: formData,
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });

      // Fetch updated cart data
      await fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          // update item count in drawer header
          const newCount = cart.item_count;
          const drawerCount = document.querySelector(".drawer__item-count");
          const countBubble = document.querySelector(".cart-count-bubble");
          const countBubbleSpan = document.querySelectorAll(
            ".cart-count-bubble span"
          );
          const emptyHeader = document.querySelector(
            ".cart-drawer__empty-content"
          );
          const emptyCollections = document.querySelector(
            ".cart__empty-collections"
          );

          // Hide empty collections section if new item added
          if (emptyCollections && newCount > 0) {
            emptyCollections.style.display = "none";
          }

          // Hide empty cart header if new item added
          if (emptyHeader && newCount > 0) {
            emptyHeader.style.display = "none";
          }

          // Update count bubble
          if (countBubble && newCount > 0) {
            countBubble.classList.remove("ws-hide-count");

            countBubbleSpan.forEach((span) => {
              span.innerHTML = newCount;
            });
          }

          // Update drawer count
          if (drawerCount && newCount) {
            drawerCount.innerHTML = newCount;
          }
        });

      // Fetch updated cart drawer HTML
      await fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          // parse the response HTML
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          const outerDrawer = document.querySelector("cart-drawer");
          outerDrawer.classList.remove("is-empty");

          // replace existing cart items with updated items
          const targetElement = document.querySelector("cart-drawer-items");
          const sourceElement = html.querySelector("cart-drawer-items");

          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }

          // update cart footer
          const targetFooter = document.querySelector(".drawer__footer");
          const sourceFooter = html.querySelector(".drawer__footer");

          if (targetFooter && sourceFooter) {
            targetFooter.replaceWith(sourceFooter);
          }

          // open cart drawer
          cart.classList.add("active");
          button.disabled = false;
          if (spinner) {
            spinner.classList.add("hidden");
          }
        })
        .catch((error) => {
          console.error("Error updating cart drawer:", error);
        });
    });
  });
}

init();
